// list of various application logins
export enum AuthPlatformEnum {
    Zendesk = 'zendesk'
}
